const chatEndpoints = {
    createNewConversation: "/chat/create-new-conversation",
    getAllConversationUser : "/chat/get-all-conversation-user/:userId",
    getAllMessages: "/message/get-all-messages/:conversationId",
    createNewMessage: "/message/create-new-message",
  };
  
export default chatEndpoints;